<div class="view-content">
  @if (!!device) {
    <div>
      @if (nativeVideoRecordingAvailable) {
        <div class="video-type-switch">
          <div class="native" pTooltip="Take video recording from the browser">Live</div>
          <p-toggle-switch [disabled]="recordInProgress" [(ngModel)]="wantNativeVideoRecording" [attr.data-testing-id]="'workbench-nativevideo-toggle'"></p-toggle-switch>
          <div class="native" pTooltip="Take native video recording in device">Native</div>
        </div>
      }
      @if(!wantNativeVideoRecording) {
        <div class="hint">
          Note: Switching tabs will automatically end the recording.
        </div>
      }
      <div class="action-group">
        @if (!recordInProgress) {
          <p-button label="Start Recording" (onClick)="startRecording()" data-testing-id="start_recording_btn"></p-button>
        }
        @if (recordInProgress) {
          <p-button label="Stop Recording" (onClick)="stopRecording()" data-testing-id="stop_recording_btn"></p-button>
        }
      </div>
      @if (!!finishedVideoRecording) {
        <div class="open-link" (click)="openVideoInViewer()" data-testing-id="open_video_btn">
          Open Finished Video <fa-icon [icon]="faExternalLink"></fa-icon>
        </div>
      }
      @if (activeTestRun || activeActivity) {
        <div class="select-finding">
          <wm-select-finding [selectedFinding]="preselectedFinding" [addAutomaticallyToFinding]="!!preselectedFinding" (stateChanged)="handleFindingStateChange($event)"></wm-select-finding>
        </div>
      }
    </div>
  }
</div>
